import { Injectable, inject } from '@angular/core';
import { ConfigService } from '@shared/services/config.service';
import { DataService } from '@shared/services/data.service';

@Injectable({
  providedIn: 'root',
})
export class ClubHubDataService extends DataService {
  public constructor() {
    const configService = inject(ConfigService);
    super(configService.config?.clubHubApiUrl ?? '');
  }
}
